<template>
  <v-row no-gutters style="max-height: 75px">
    <!-- mobile size avatar and menu -->
    <AvatarIconMenu />
    <v-card-subtitle class="d-flex flex-column text-grey pt-0">
      <span
        class="font-weight-medium text-h6 text-pwt_black font-weight-medium"
      >
        {{ user?.fullName ?? "Guest user" }}
      </span>
      <span class="text-pwt_black font-weight-light">
        {{ user?.email }}
      </span>
      <span v-if="companyName" class="text-pwt_black font-weight-light">
        {{ companyName }}
      </span>
    </v-card-subtitle>
    <v-spacer />
  </v-row>
</template>

<script lang="ts" setup>
import { useFleetStore } from "@/domains/fleet/fleetStore.ts";
import { useUserStore } from "@/domains/user/userStore.ts";
import { computed } from "vue";
import AvatarIconMenu from "./AvatarIconMenu.vue";

const userStore = useUserStore();
const user = computed(() => userStore.getCurrentUser);

const fleetStore = useFleetStore();
const companyName = computed(() => fleetStore.fleetName);
</script>
